// eslint-disable-next-line import/prefer-default-export
export const TOGGLE_POSITION = 'togglePosition';
